import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Chip } from "@mui/material";
export const TagChips = ({ tags, wrap = true, boxProps }) => {
    return (_jsx(Box, { display: "flex", flexDirection: "row", alignItems: "baseline", flexWrap: wrap ? "wrap" : "nowrap", sx: { ml: -0.5, mt: -0.25 }, ...boxProps, children: tags.map((tag, index) => (_jsx(Chip, { variant: "outlined", clickable: false, label: tag, size: "small", sx: { ml: 0.5, mt: 0.25 } }, `${tag}-${index}`))) }));
};
//# sourceMappingURL=TagChips.js.map